import NewsletterTwelveContainer from "./containers/NewsletterTwelveContainer";
export default NewsletterTwelveContainer;
